<template>
    <section class="c-instagram" :class="[background, spaces]">
        <div class="c-container">
            <div class="c-instagram__headline c-headline psb-30 psb-md-60">
                <h2 class="headline">Instagram</h2>
                <NuxtLink
                    to="https://www.instagram.com/puq.coffee/"
                    class="arrow-link dark"
                    title="Follow us"
                    target="_blank"
                >
                    <span class="icon"><SvgsArrowRight /></span>
                    <span class="text">Follow us</span>
                </NuxtLink>
            </div>
            <ClientOnly>
                <div v-if="!!feed.length" class="c-instagram__grid">
                    <div class="instagram__preview">
                        <SvgsInstagram />
                    </div>
                    <CardsInstagram v-for="post in feed" :key="post.id" :post="post" />
                </div>
            </ClientOnly>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        background: {
            type: String,
            default: "bg-white"
        },
        spaces: {
            type: String,
            default: "pst-75 psb-75 pst-md-150 psb-md-150"
        }
    });

    const globalStore = useGlobalStore();
    const { instagramFeed } = storeToRefs(globalStore);

    const feed = computed(() =>
        !!Object.keys(instagramFeed.value).length
            ? instagramFeed.value?.posts.sort(() => 0.5 - Math.random()).slice(0, 3)
            : []
    );
</script>
